
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 -1 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#D2D5D9"}}),_c('path',{staticClass:"black-fill",attrs:{"d":"M6.021 10.652c.103 2.039.458 3.822 1.073 5.384.466 1.186 1.089 2.241 1.836 3.112.305.355.66.71 1.007 1.007 1.51 1.291 3.428 2.062 5.658 2.267.431.04.684.053 1.223.058l.465.005v-2.23c0-1.226.003-2.23.006-2.23a5.66 5.66 0 013.154 1.365c.867.744 1.57 1.801 1.956 2.943l.05.147h1.778c1.689 0 1.778 0 1.773-.013 0-.008-.019-.058-.034-.116a9.922 9.922 0 00-2.134-3.871 9.879 9.879 0 00-2.39-1.96 7.822 7.822 0 00-.487-.258l-.084-.039.108-.066c.75-.455 1.53-1.13 2.18-1.886a9.533 9.533 0 001.323-1.98 8.186 8.186 0 00.766-2.28c0-.008-.28-.011-1.613-.011h-1.612l-.013.05c-.024.087-.148.455-.197.586a8.156 8.156 0 01-1.868 2.862c-.841.826-1.757 1.32-2.635 1.428h-.024V10H14.06v4.319c0 3.698 0 4.318-.01 4.318-.02 0-.243-.065-.345-.102a4.766 4.766 0 01-1.344-.763c-1.597-1.289-2.594-3.54-2.862-6.462-.029-.31-.052-.705-.063-.981 0-.074-.005-.18-.008-.232L9.422 10H6v.053c0 .07.013.412.021.6z","fill":"#fff"}})])
          )
        }
      }
    